module.exports = __webpack_public_path__ + "img/case11.f8634ea6.png";